import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { HeadArea } from './headArea/HeadArea';
import { BackButton } from './backButton/BackButton';
import { useGetBenefitsListPage } from '../../customHooks/useGetBenefitsListPage.hook';
import { useCheckShouldDisplayWelcomeModal } from '../../customHooks/useCheckShouldDisplayWelcomeModal.hook';
import { BenefitPageState } from '../../@types/benefitPageState';
import { ContentArea } from './contentArea/ContentArea';

export const BenefitsPage = ({ benefitPageState }: { benefitPageState: BenefitPageState }) => {
  const [searchParams] = useSearchParams();
  const isMobileView = searchParams.get('headless') === 'true' || searchParams.get('isMobileView') === 'true';
  const benefitsPageListPage = useGetBenefitsListPage();
  useCheckShouldDisplayWelcomeModal(benefitsPageListPage);

  return (
    <>
      {!isMobileView && <BackButton />}
      <HeadArea />
      {/* TODO: revisit this to simplify application setup (check: https://github.com/Scout24/is24-mein-plus-benefits-frontend/pull/1081#discussion_r1539072182) */}
      <ContentArea benefitPageState={benefitPageState} />
    </>
  );
};
